import { render, staticRenderFns } from "./PortfolioPiece.vue?vue&type=template&id=2a940089"
import script from "./PortfolioPiece.vue?vue&type=script&lang=js"
export * from "./PortfolioPiece.vue?vue&type=script&lang=js"
import style0 from "./PortfolioPiece.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports